import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllNotificationPositions,
  GetNotificationPositionById,
} from "../../services/NotificationPositionService";

const initialState = {
  noticeCategoryNotifications: [] as any,
  status: "idle",
  error: "" as string | undefined,
};

export const fetchNoticeCategoryNotifications = createAsyncThunk(
  "/noticeCategoryNotifications/fetchNoticeCategoryNotifications",
  async (positionId: any) => {
    const response = await GetAllNotificationPositions(positionId);
    //console.log(response.data.data);
    return response.data;
  }
);

export const updateNoticeCategoryNotifications = createAsyncThunk(
  "/noticeCategoryNotifications/updateNoticeCategoryNotifications",
  async (data: any) => {
    const response = await GetNotificationPositionById(data.Id);

    return { message: response.data.data, id: data.groupId };
  }
);

const noticeCategoryNotificationsSlice = createSlice({
  name: "noticeCategoryNotifications",
  initialState: initialState,
  reducers: {
    noticeCategoryNotificationAdded: (state, action: PayloadAction<any>) => {
      state.noticeCategoryNotifications.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNoticeCategoryNotifications.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(
        fetchNoticeCategoryNotifications.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.noticeCategoryNotifications = action.payload.data;
          //	console.log(state.groups);

          state.status = "idle";
        }
      )
      .addCase(fetchNoticeCategoryNotifications.rejected, (state, action) => {
        //console.log(action);
        state.error = action.error.message;
        state.status = "idle";
      })
      .addCase(updateNoticeCategoryNotifications.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateNoticeCategoryNotifications.fulfilled, (state, action) => {
        //	console.log("apl", action.payload);

        const updateIndex = state.noticeCategoryNotifications.findIndex(
          (p: any) => p.id === action.payload.id
        );
        //	console.log(updateGroupIndex);

        if (updateIndex === -1) {
          console.log(-1);
        } else {
          const messageIndex = state.noticeCategoryNotifications[
            updateIndex
          ].messages.findIndex((p: any) => p.id === action.payload.message.id);

          if (messageIndex === -1) {
            //do something
            //state.noticeCategoryNotifications[updateIndex].messages.push(action.payload.message);
          }
        }

        state.status = "idle";
      })
      .addCase(updateNoticeCategoryNotifications.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "idle";
      });
  },
});

export const selectAllNoticeCategoryNotifications = (state: any) =>
  state.noticeCategoryNotifications.noticeCategoryNotifications;
export const { noticeCategoryNotificationAdded } =
  noticeCategoryNotificationsSlice.actions;

export default noticeCategoryNotificationsSlice.reducer;
